import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import AccessDeniedModal from "./AccessDeniedModal";
import Loader from "../utils/Loader";

/**
 * Permission Guard Component
 * 
 * Protects routes based on user permissions.
 * If user doesn't have required permissions, shows AccessDeniedModal
 * or redirects to dashboard.
 */
const PermissionGuard = ({
  children,
  checkPermission,
  redirectTo = "/dashboard",
  showModal = true,
  title,
  message,
}) => {
  const admin = useSelector((state) => state.admin.txtconnect_ng_admin);
  const location = useLocation();
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const [hasPermission, setHasPermission] = useState(null);

  useEffect(() => {
    if (!admin) {
      setHasPermission(false);
      return;
    }

    // Check permission using the provided function
    const hasAccess = checkPermission ? checkPermission(admin) : true;
    setHasPermission(hasAccess);

    if (!hasAccess && showModal) {
      setShowAccessDenied(true);
    }
  }, [admin, checkPermission, showModal]);

  if (hasPermission === null) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-white">
        <Loader />
      </div>
    );
  }

  if (!hasPermission && !showModal) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  if (!hasPermission && showModal) {
    return (
      <>
        {children}
        <AccessDeniedModal
          isOpen={showAccessDenied}
          onClose={() => {
            setShowAccessDenied(false);
            window.history.back();
          }}
          title={title}
          message={message}
        />
      </>
    );
  }

  return <>{children}</>;
};

export default PermissionGuard;

